

























































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import Application from '../../types/app/application';
import Profile from '../../types/app/profile';
import Header from '../../types/app/header';
import ProfileHeader from '../../types/app/profileHeader';

import Endpoint from '../../utils/endpoint';

@Component({})
export default class IndexProfile extends Vue {
  @Action('setApplicationId', { namespace: 'profile' }) setApplicationId!: any;

  headers: Array<Header> = ProfileHeader.header;

  applications: Array<Application> = [];
  profiles: Array<Profile> = [];
  loading = false;
  gettingApplications = true;
  filter = {
    applicationId: null
  };

  async created() {
    await this.getApplications();
  }

  async getApplications(): Promise<void> {
    try {
      const resp: any = await this.$http.get(Endpoint.Url.profile.getApplications);
      if (resp.statusCode.item1 === 200) {
        this.applications = resp.data;
      }

      this.gettingApplications = false;
    } catch (error) {
      this.gettingApplications = false;
      console.log('error');
    }
  }

  async getProfiles(): Promise<void> {
    try {
      this.loading = true;
      const resp: any = await this.$http.get(`${Endpoint.Url.profile.getProfiles}/${this.filter.applicationId}`);
      console.log('profiles', JSON.parse(JSON.stringify(resp)));

      if (resp.statusCode.item1 === 200) {
        this.profiles = resp.data;
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      console.log('error', error);
    }
  }

  goToDetail(item: any): void {
    this.$router.push({ name: 'FormProfile', params: { id: item.id } });
  }

  goToCreate(): void {
    this.setApplicationId(this.filter.applicationId);
    this.$router.push({ name: 'FormProfile' });
  }
}
